import React, { FC } from 'react';
import { Image as ImageMedia } from '@fiverr-private/media';

const responsiveImageData = {
  sizes: ['(min-width: 900px) 430px', '(min-width: 480px) 600px', '430px'],
  srcSet: [430, 860, 300, 600], // 860 and 600 used for retina
};

function getImageData(url) {
  const isImageScalable = new RegExp(/w_[0-9]{3,4}/).test(url);

  return {
    srcSet: isImageScalable
      ? responsiveImageData.srcSet.map((size) => `${url.replace(/w_[0-9]{3,4}/, `w_${size}`)} ${size}w`)
      : [url],
    sizes: responsiveImageData.sizes,
  };
}

interface ImageProps {
  src: string;
  alt: string;
}

const Image: FC<ImageProps> = ({ src, alt = '', ...props }) => {
  if (!src) {
    return null;
  }

  const { srcSet, sizes } = getImageData(src);

  return srcSet.length > 1 ? (
    <ImageMedia
      srcSet={srcSet.join(', ')}
      sizes={sizes.join(', ')}
      src={srcSet[srcSet.length - 1].split(' ').shift()}
      alt={alt}
      title={alt}
      loading="lazy"
      borderRadius="sm"
      width="100%"
      height="100%"
      objectFit="cover"
      position="absolute"
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
      display="block"
      {...props}
    />
  ) : (
    <ImageMedia src={srcSet[0].split(' ').shift()} alt={alt} title={alt} loading="lazy" />
  );
};

export default Image;
